import {
  BooleanCellRendererComponent,
  BooleanToAdverbFilterComponent,
  BooleanToAdverbsRendererComponent,
  CustomDateFilterComponent,
  CustomRendererComponent,
  CustomTooltipComponent,
  DateFormatterRendererComponent,
  EnumRendererComponent,
  EnumToAdverbFilterComponent,
  EnumToAdverbsFilterCellRendererComponent,
  FileSizeFormatterRendererComponent,
  FooterRenderComponent,
  LevelFormatterRendererComponent,
  ListFormatterRendererComponent,
  LockFormatterRendererComponent,
  OverlayLoadingRendererComponent,
  ProgressFormatterRendererComponent,
  RegulationTypeRendererComponent,
  ResourceSubTypeFormatterRendererComponent,
  ScenarioFormatterRendererComponent,
  StatusFormatterRendererComponent,
  TranslateServiceRendererComponent
} from './ag-grid';
import { Languages } from '@pt/pt-models';
import { CustomHeaderTooltipComponent } from './ag-grid/custom-header-tooltip/custom-header-tooltip.component';

export const ag_grid_frameworkComponents = {
  customRendererComponent: CustomRendererComponent,
  customTooltipComponent: CustomTooltipComponent,
  customHeaderTooltip: CustomHeaderTooltipComponent,
  lockFormatterRenderer: LockFormatterRendererComponent,
  overlayLoadingRenderer: OverlayLoadingRendererComponent,
  dateFormatterRenderer: DateFormatterRendererComponent,
  agDateInput: CustomDateFilterComponent,
  booleanToAdverbsRendererComponent: BooleanToAdverbsRendererComponent,
  booleanToAdverbFilterComponent: BooleanToAdverbFilterComponent,
  booleanCellRenderer: BooleanCellRendererComponent,
  scenarioFormatterRenderer: ScenarioFormatterRendererComponent,
  enumToAdverbsFilterCellRendererComponent: EnumToAdverbsFilterCellRendererComponent,
  enumToAdverbFilterComponent: EnumToAdverbFilterComponent,
  enumRendererComponent: EnumRendererComponent,
  translateServiceRenderer: TranslateServiceRendererComponent,
  listFormatterRenderer: ListFormatterRendererComponent,
  statusFormatterRenderer: StatusFormatterRendererComponent,
  levelFormatterRenderer: LevelFormatterRendererComponent,
  resourceSubTypeFormatterRenderer: ResourceSubTypeFormatterRendererComponent,
  regulationTypeRendererComponent: RegulationTypeRendererComponent,
  footerRenderComponent: FooterRenderComponent,
  fileSizeRenderer: FileSizeFormatterRendererComponent,
  progressRenderer: ProgressFormatterRendererComponent
};


export const ag_grid_components = {
  customRendererComponent: 'customRendererComponent',
  customTooltipComponent: 'customTooltipComponent',
  lockFormatterRenderer: 'lockFormatterRenderer',
  overlayLoadingRenderer: 'overlayLoadingRenderer',
  dateFormatterRenderer: 'dateFormatterRenderer',
  agDateInput: 'agDateInput',
  booleanToAdverbsRendererComponent: 'booleanToAdverbsRendererComponent',
  booleanToAdverbFilterComponent: 'booleanToAdverbFilterComponent',
  booleanCellRenderer: 'booleanCellRenderer',
  enumToAdverbsFilterCellRendererComponent: 'enumToAdverbsFilterCellRendererComponent',
  enumToAdverbFilterComponent: 'enumToAdverbFilterComponent',
  enumRendererComponent: 'enumRendererComponent',
  translateServiceRenderer: 'translateServiceRenderer',
  listFormatterRenderer: 'listFormatterRenderer',
  statusFormatterRenderer: 'statusFormatterRenderer',
  levelFormatterRenderer: 'levelFormatterRenderer',
  resourceSubTypeFormatterRenderer: 'resourceSubTypeFormatterRenderer',
  regulationTypeRendererComponent: 'regulationTypeRendererComponent',
  footerRenderComponent: 'footerRenderComponent',
  fileSizeRenderer: 'fileSizeRenderer',
  progressRenderer: 'progressRenderer'
};
export const languagesList_inputSelectComponent = [
  {
    label: 'LANGUAGES.ITALIAN',
    value: Languages.ITALIAN
  }
  // {
  //   label: 'LANGUAGES.ENGLISH',
  //   value: Languages.ENGLISH
  // }
];
